import { useState } from 'react';
import { Group, ActionIcon, Tooltip } from '@mantine/core';
import { IconThumbUp, IconThumbDown } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { api } from '../../lib/api';

interface FeedbackButtonsProps {
  messageId: string;
  sessionId: string;
}

/**
 * Daumen hoch/runter für Assistant-Nachrichten (persistiert via API).
 */
export function FeedbackButtons({ messageId, sessionId }: FeedbackButtonsProps) {
  const [sent, setSent] = useState<1 | -1 | null>(null);

  const send = async (rating: 1 | -1) => {
    if (sent !== null) return;
    try {
      await api.postFeedback(messageId, { sessionId, rating });
      setSent(rating);
      notifications.show({ message: 'Danke für dein Feedback!', color: 'teal' });
    } catch (e) {
      notifications.show({
        message: e instanceof Error ? e.message : 'Feedback konnte nicht gesendet werden',
        color: 'red',
      });
    }
  };

  return (
    <Group gap={2}>
      <Tooltip label="Hilfreich" withArrow>
        <ActionIcon
          size="sm"
          variant="subtle"
          color={sent === 1 ? 'teal' : 'gray'}
          aria-label="Hilfreich"
          onClick={() => void send(1)}
          disabled={sent !== null}
        >
          <IconThumbUp size={16} />
        </ActionIcon>
      </Tooltip>
      <Tooltip label="Nicht hilfreich" withArrow>
        <ActionIcon
          size="sm"
          variant="subtle"
          color={sent === -1 ? 'red' : 'gray'}
          aria-label="Nicht hilfreich"
          onClick={() => void send(-1)}
          disabled={sent !== null}
        >
          <IconThumbDown size={16} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}
